import { createFileRoute } from "@tanstack/react-router";
import { useCompetitions } from "../../../../api/useCompetitions";
import LoadingScreen from "../../../../features/Layout/LoadingScreen/LoadingScreen";
import EditCompetitionPage from "../../../../pages/Admin/Competitions/EditCompetitionPage";
import QueryError from "../../../../components/QueryError/QueryError";

export const Route = createFileRoute("/(app)/admin/competitions/$id/edit")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { data, isPending, isError, error, refetch, isRefetching } =
    useCompetitions();

  if (isError)
    return (
      <QueryError
        error={error}
        onRetry={() => refetch()}
        isRetrying={isRefetching}
      />
    );
  if (isPending) return <LoadingScreen />;

  const competition = data.map.get(Number(id));
  if (!competition) return <QueryError type="notFound" />;

  return <EditCompetitionPage competition={competition} />;
}
